import { contents } from ".."
import SkillItem from "../../components/SkillItem"

const ThienSangWedding = () => {
    const filteredProjects = contents.filter((item) => item.slug === 'thien-sang-wedding')
    const project = filteredProjects[0]
    
    return (
        <div className="overflow-hidden bg-white py-24 sm:py-32 rounded-md">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
                    <div className="lg:pr-8 lg:pt-4">
                        <div className="lg:max-w-lg">
                            <h2 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">My Wedding Guest Website</h2>
                            <div className="my-4">
                                {project.techStack.map((item, index: number) => {
                                    return (
                                        <SkillItem key={`landl-index-${index}-${item}`} label={item} />
                                    )
                                })}
                            </div>
                            <p className="mt-6 text-lg leading-8 text-gray-600 text-justify">
                                In early 2023, I built a website for my wedding. Guests could use it to say if they would attend and share their food choices and allergies. We planned the wedding by guest count rather than by table bookings, so the website helped me keep track of everyone.
                            </p>
                            <div>
                                <img
                                    src={require('../../assets/projects/wedding/thien_sang_wedding_intro.png')}
                                    alt="thiensangwedding.com"
                                    className="rounded-xl shadow-xl ring-1 ring-gray-400/10"
                                    width={2432}
                                    height={1442}
                                />
                            </div>
                            <p className="mt-6 text-lg leading-8 text-gray-600 text-justify">
                                I bought the domain <a className="text-indigo-600" href="https://thiensangwedding.com" target='_blank' rel="noreferrer">https://thiensangwedding.com</a> (The original site is now closed. You can see a saved copy here: <a className="text-indigo-600" href="https://thientd.dev/thien-sang-wedding/" target='_blank' rel="noreferrer">https://thientd.dev/thien-sang-wedding/</a>) and used Firebase Hosting to keep costs low.<br /><br /> I built the main website with HTML, JavaScript, and CSS. I used ReactJS and TypeScript for the form where guests could confirm they would attend.
                            </p>
                            <p className="mt-6 text-lg leading-8 text-gray-600 text-justify">
                                I used Supabase Functions to handle form requests and Supabase Database to store guest details. This helped me check the guest list and plan for the wedding.
                            </p>
                            
                        </div>
                    </div>
                    <video className="rounded-xl shadow-xl ring-1 ring-gray-400/10" controls>
                        <source src={require('../../assets/videos/unboxing_thiensangwedding_card.mp4')} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </div>
                <br />
                <div className="flex items-center w-full justify-center flex-col">
                    <img
                        src={require('../../assets/projects/wedding/supabase_database.png')}
                        alt="Guest notes"
                        className="w-[48rem] max-w-none rounded-xl shadow-xl ring-1 ring-gray-400/10 sm:w-[57rem] md:-ml-4 lg:-ml-0"
                        width={2432}
                        height={1442}
                    />
                    <p className="text-gray-600">Guest notes</p>
                </div>
            </div>
        </div>
    )
}

export default ThienSangWedding
